const config = {
    VITE_STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'test',
    VITE_API_URL: import.meta.env.VITE_API_URL || 'http://localhost:5000',
    VITE_API_URL_v1: import.meta.env.VITE_API_URL_v1 || 'http://localhost:5000/v1',
    GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
    VITE_BASE_DOMAIN: import.meta.env.VITE_BASE_DOMAIN || 'localhost',
    VITE_PRICING_FREE_ID: import.meta.env.VITE_PRICING_FREE_ID || 'MISSING', 
    VITE_PRICING_PRO_ID: import.meta.env.VITE_PRICING_PRO_ID || 'MISSING', 
    VITE_PRICING_PREMIUM_ID: import.meta.env.VITE_PRICING_PREMIUM_ID || 'MISSING',
    VITE_HOME_ROUTE: import.meta.env.VITE_HOME_ROUTE || '/',
    VITE_APP_NAME: import.meta.env.VITE_APP_NAME || 'YouTube Analyzer',
    VITE_DEBUG: import.meta.env.VITE_DEBUG === 'true',
    NODE_ENV: import.meta.env.NODE_ENV || 'development',
    VITE_PUBLIC_ROUTES: [
      '/', '/about', '/pricing', '/login', '/register', '/forgot-password', 
      '/verify-email/:uidb64/:token', '/resend-verification', '/reset-password/:uidb64/:token', 
      '/password-reset/:uidb64/:token', '/docs', '/channel-discovery', 
      '/video-discovery', '/video-info/:videoId'
    ],
    VITE_PRICING: {
      "free": {
        "month": 0,
        "annual": 0
      },
      "pro": {
        "month": 15,
        "annual": 9,
        "annual-save-percent": 40,
        "annual-save": 72
      },
      "premium": {
        "month": 20,
        "annual": 12,
        "annual-save-percent": 40,
        "annual-save": 96
      }
    },
    VITE_AD_CLIENT: import.meta.env.VITE_AD_CLIENT
}   
export default config;